// Generated sandbox code: SSVMN - PlusTools - Editor v6.5.0 - 22/02/2022
// Created/Updated by jcanales - 28/08/2023

import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy } from '@angular/core'
import { BaseController } from './base.controller';
import { Action, CtButtonCompressedContainerComponent, CtFormComponent, CtInputTextComponent, HttpService } from 'components';
import { Router } from '@angular/router';
import { defaultIfEmpty, take } from 'rxjs/operators';
import { Subscription, combineLatest } from 'rxjs';

@Component({
	selector: 'pa-vi02',
	template: `<div [id]="getId()" #target><div>`
})

export class PaVi02 extends BaseController implements OnDestroy{

	public numPlanilla: number;
	public docIdPatrono : string;
	public buttons : any[] = [];
	public mainAction : Action;

	//util 
	private subcriptions : Subscription[] = [];

	constructor(private router : Router) {
		super();
		this.setViewCode('PA_VI02');
	}

	ngOnDestroy(): void {
		this.subcriptions.forEach(sub => sub.unsubscribe());
	}

	/* ---------------------- CONTROLLER LOGIC ------------------- */
	public validateViewData(event : Action){
		const numPlanilla : CtInputTextComponent = this.utilService.getComponentRef(event.actionParams[0]);
		const docIdPatrono : CtInputTextComponent = this.utilService.getComponentRef(event.actionParams[1]);
		if(numPlanilla.getValue() === '' || docIdPatrono.getValue() === ''){
			this.router.navigate(['home/view/PA_VI01']);
		}
	}

	public goToPaymentScreen(): void {
		this.router.navigate(['home/view/PA_VI04']);
	}

	public setButtonContainerByStatus(action : Action): void {
		const form : CtFormComponent = this.utilService.getComponentRef(action.actionParams[0]);
		const buttonContainer : CtButtonCompressedContainerComponent = this.utilService.getComponentRef(action.actionParams[1]);
		const planillaStatus : string = form.getFormControl('ESTADO').value;
		this.hideButtonInContainer(buttonContainer, planillaStatus);
	}

	private hideButtonInContainer(buttonContainer: CtButtonCompressedContainerComponent, planillaStatus: string) {
		this.buttons = [...buttonContainer.getMetaData().models];
		switch ((planillaStatus['ESTADO']).toUpperCase()) {
			case 'APLICADA':
				buttonContainer.removeButtonsFromWindow(['EDITAR','REVERTIR','PAGAR_PLANILLA']);
				break;
			case 'REVISIÓN':
				buttonContainer.removeButtonsFromWindow(['PAGAR_PLANILLA']);
				break;
			default:
				buttonContainer.removeButtonsFromWindow(['EDITAR','REVERTIR','PAGAR_PLANILLA']);
		}
	}

	public downloadReport(action : Action): void {
		const form : CtFormComponent = this.utilService.getComponentRef(action.actionParams[0]);
		this.numPlanilla = (this.utilService.getComponentRef(action.actionParams[1]) as CtInputTextComponent).getValue();
		let tipPlanilla : string = form.getFormControl('RAW_TIP').value.RAW_TIP;
		tipPlanilla = tipPlanilla === 'MUT' ? 'M' : 'C';
		const reportData = this.getReportData(this.numPlanilla, tipPlanilla);
		let nameTipPlanilla : string;
		if(tipPlanilla== 'M'){
		  nameTipPlanilla = 'póliza mutual'
		} else nameTipPlanilla = 'crédito'

		let periodoComponent: CtInputTextComponent = this.utilService.getComponentRef('txtCtInputText_e64c13f2');
		let valuePeriodo = periodoComponent.getValue();
		let periodoFormated = this.convertMonthYearToYearMonth(valuePeriodo);
		this.requestReportData(reportData,'pdf', `Planilla de ${nameTipPlanilla} ${periodoFormated}`);
	}

	private convertMonthYearToYearMonth(input: string): string {
		const upperInput = input.toUpperCase();
		const monthMap: { [key: string]: string } = {
			'ENERO': '01', 'FEBRERO': '02', 'MARZO': '03', 'ABRIL': '04', 'MAYO': '05', 'JUNIO': '06',
			'JULIO': '07', 'AGOSTO': '08', 'SEPTIEMBRE': '09', 'OCTUBRE': '10', 'NOVIEMBRE': '11', 'DICIEMBRE': '12'
		  };
		const parts = upperInput.split(' - ');
		const month = parts[0];
		const year = parts[1];
	
		return `${year}${monthMap[month]}`;
	  }

	public goToEditPlanilla(acion : Action): void {

		const { numPlanilla, docIdPatrono, tipPlanilla, periodoPlanilla }: 
			{ numPlanilla: number; docIdPatrono: string; tipPlanilla: string; periodoPlanilla : string } = this.getActionDataToEditPlanilla(acion);

		this.setActionDataToStoreToEditPlanilla(numPlanilla, docIdPatrono, tipPlanilla, periodoPlanilla);
		this.router.navigate(['home/view/PA_VI03']);
	}

	private setActionDataToStoreToEditPlanilla(numPlanilla: number, docIdPatrono: string, tipPlanilla: string, periodoPlanilla : string) {
		this.storeService.setState('numPlanilla', numPlanilla);
		this.storeService.setState('docIdPatrono', docIdPatrono);
		this.storeService.setState('isEditing', true);
		this.storeService.setState('tipPlanilla', tipPlanilla === 'MUT' ? 'M' : 'C');
		this.storeService.setState('periodoPlanilla', periodoPlanilla);
	}

	private getActionDataToEditPlanilla(acion: Action) {
		const numPlanilla: number = (this.utilService.getComponentRef(acion.actionParams[0]) as CtInputTextComponent).getValue();
		const tipPlanilla: string = (this.utilService.getComponentRef(acion.actionParams[1]) as CtInputTextComponent).getValue();
		const docIdPatrono: string = (this.utilService.getComponentRef(acion.actionParams[2]) as CtInputTextComponent).getValue();
		const periodoPlanilla: string = this.getFullDateFromForm(acion.actionParams[3]);
		return { numPlanilla, docIdPatrono, tipPlanilla, periodoPlanilla };
	}

	private getFullDateFromForm(formId: string): string {
		const form : CtFormComponent = (this.utilService.getComponentRef(formId) as CtFormComponent);
		const elements : CtInputTextComponent[] = form.getFormElements();
		return elements.find((element) => element.getModelId() === 'FULL_DATE').getValue();
	}

	private getReportData(numPlanilla : number, tipPlanila : string): any {
		return {
			"format": "PDF",
			"source": this.getViewCode(),
			"sendTo": null,
			"requireDownloadURL":false,
			"parameters": [
			  {
				"name": "P_NUM_PLAN",
				"value": numPlanilla
			  },
			  {
				"name": "P_TIP_PLAN",
				"value": tipPlanila
			  }
			]
		};
	}

	private requestReportData(reportData: any, fileType: string , fileName: string) {
		this.subcriptions.push(this.httpService.post(HttpService.ENDPOINT + '/api/Report/Generate/PM_RE06', reportData).subscribe({
		   next: (data: any) => {
			 const report: any = data.data[0];
			 this.componentService.utl_downloadReport(report, fileType, fileName);
		   },
		   error: (error: any) => {
			 this.plusAlertService.setCtDialogInfo('Descarga del reporte fallida.', 'error',
			   'error', 'primary', 'Lo sentimos, la descarga del reporte de la planilla no se pudo completar. Por favor, verifica que tu conexión a Internet está funcionando correctamente y luego intenta descargar el reporte una vez más.',
			   true, 'Finalizar', 'Cancelar');
		   }
		 }));
	   }
	 

	private downloadOnBrowser(report: any) {
		try {
			let byteArray = this.utilService.getByteArray(report);
			let blob = new Blob([byteArray], { type: 'application/pdf' });
			this.utilService.createAdownloadATag(blob, 'PLANILLA_' + this.numPlanilla);
		  } catch (error) {
			throw new Error("");
		  }
	}

	/* -------------------- END CONTROLLER LOGIC ----------------- */
}